import { useEffect, useState } from "react";
import { fetchUserAttributes } from "@aws-amplify/auth";

/**
 * The logged-in user's Cognito `name` ("First Last", the same format as the
 * Product Contact options and created_by). `undefined` while loading, and ""
 * if it couldn't be read.
 */
export function useCurrentUserName(): string | undefined {
  const [name, setName] = useState<string | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchUserAttributes()
      .then((attrs) => {
        if (!cancelled) setName(attrs.name ?? "");
      })
      .catch((err) => {
        console.log(err);
        if (!cancelled) setName("");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return name;
}
